import React, { useCallback } from 'react';
import type { GlobalProps } from '@bloomberg/media-ui-core';
import { classes, IconButton, useSlug } from '@bloomberg/media-ui-core';
import { CheckmarkStroke, PlusThinStroke } from '@bloomberg/media-ui-icons';

import styles from './QuickAddIcon.module.css';

export type QuickAddIconProps = GlobalProps & {
  isFollowing?: boolean;
  onClick?: () => void;
  showText?: boolean;
  size?: 'small' | 'default';
  trackingFunction?: () => void;
};

export const QuickAddIcon = React.forwardRef<HTMLDivElement, QuickAddIconProps>(
  function QuickAddIconComponent(props: QuickAddIconProps, ref) {
    const {
      isFollowing = false,
      name = 'quick-add-icon',
      onClick = null,
      showText = false,
      size = 'default',
      trackingFunction = null,
    } = props;

    const [componentName] = useSlug(name);
    const isSmall = size === 'small';

    const handleOnClick = useCallback(() => {
      trackingFunction?.();
      onClick?.();
    }, [onClick, trackingFunction]);

    return (
      <div
        className={classes([styles.quickAddIcon, isSmall && styles.small], {
          ...props,
          name,
        })}
        ref={ref}
        data-component={componentName}
        onClick={handleOnClick}
      >
        <IconButton className={styles.button} size={size}>
          {isFollowing ? (
            <CheckmarkStroke title="Following" />
          ) : (
            <PlusThinStroke title="Follow" />
          )}
        </IconButton>
        {showText && (
          <span className={styles.followText}>
            {isFollowing ? 'Following' : 'Follow'}
          </span>
        )}
      </div>
    );
  }
);
